const NAMESPACE = 'TcmDlr-'

export function saveToLocalStorage(param, value) {
  localStorage.setItem(NAMESPACE + param, JSON.stringify(value))
}

export function getFromLocalStorage(param) {
  const value = localStorage.getItem(NAMESPACE + param)
    ? JSON.parse(localStorage.getItem(NAMESPACE + param))
    : undefined
  return value === 'false' ? false : value
}

export function clearFromLocalStorage(param) {
  localStorage.removeItem(NAMESPACE + param)
}
